import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from '@/pages';

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: Dashboard,
});
